import http from "../utility/http";

const GetAll = async (pageNumber, pageSize = 10, filters = {}) => {
  const params = new URLSearchParams({
    pageNumber: pageNumber.toString(),
    pageSize: pageSize.toString(),
    ...filters
  });
  
  return await http.get(`/v1/notification/list?${params.toString()}`);
};

const MakeNotificationIsRead = async (notification) => {
  return await http.put(`/v1/notification/make-notification-is-read/${notification?.id}`, notification);
};

const MakeMultipleNotificationsRead = async (notificationIds) => {
  return await http.put('/v1/notification/make-multiple-notifications-read', {
    notificationIds
  });
};

const GetUnreadCount = async () => {
  return await http.get('/v1/notification/unread-count');
};


const DeleteNotification = async (notificationId) => {
  return await http.delete(`/v1/notification/${notificationId}`);
};

const GetNotificationById = async (notificationId) => {
  return await http.get(`/v1/notification/${notificationId}`);
};

const api = {
  GetAll,
  MakeNotificationIsRead,
  MakeMultipleNotificationsRead,
  GetUnreadCount,
  DeleteNotification,
  GetNotificationById
};

export default api;
